export { setVirtualParent } from '@fluentui/dom-utilities';
//# sourceMappingURL=setVirtualParent.js.map